import React, {useState, useEffect, useRef} from 'react'
import {  Grid, MenuItem , IconButton, Box, Button, Card, FormLabel, Radio, RadioGroup,FormControlLabel} from "@mui/material" ;
import { profileSettingStyles } from '../../../../styles/materialComponent';
import { CssTextField } from '../../../../styles/materialComponent';
import {useSelector, useDispatch} from "react-redux"
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import MapContainer from "../../../common/map";
import CloseIcon from '@mui/icons-material/Close';
import { fetchSpecies, fetchHealthRate ,fetchRecomendation, fetchAllTrees, getJurisdiction} from '../../../../actions/tree';
import Autocomplete from '@mui/material/Autocomplete';
import { StaticGoogleMap, Path, Marker  } from "react-static-google-map";
import { Excalidraw } from "@excalidraw/excalidraw";
import "./drawing.css";
import { s3 } from "../../../common/awsS3"
import CommonTable from '../../../common/table';
import { NotificationManager } from 'react-notifications';
import html2canvas  from "html2canvas"
import AttachmentIcon from '@mui/icons-material/Attachment';

const treeDetail=[
  "DBH",
  "Species",
  "Recomendation",
  "Tree Image",
]

export const AddTree = (props) => {
    const { formik, updateData, show, setShow, editClick,setActiveStep } = props
    const dispatch= useDispatch()
    const ref= useRef(null)
    const classes = profileSettingStyles()
    const {reports} = useSelector(({report})=> report)
    const {trees, reportTrees} = useSelector(({tree})=> tree)
  

      useEffect(()=>{
        reports?._id && dispatch(fetchAllTrees(reports?._id))
      },[reports?._id])
      
      const handleEdit=()=>{        
        formik.values.treeMapImage!=="" && formik.values.treeMapImage!==undefined ? setActiveStep(5) : setShow(true)
      }

    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>        
         { !show ? <>
         <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
         {!editClick && Object.values(trees)?.length==0 ? <IconButton
          sx={{ borderRadius:"50%",
              display:"flex",
              flexDirection:"column",
              gap:5,
              border:"1px solid rgb(115 74 153)",
              color:"rgb(115 74 153)",
              height:250,
              width:250}}
              onClick={()=> setShow(true)}
          >
          <Box sx={{textAlign:"center"}} >Add Tree</Box>
          <AddIcon sx={{fontSize:48}}/></IconButton> :
           <IconButton
          sx={{ borderRadius:"50%",
              display:"flex",
              flexDirection:"column",
              gap:5,
              border:"1px solid rgb(115 74 153)",
              color:"rgb(115 74 153)",
              height:250,
              width:250}}
              onClick={handleEdit}
          >
          <Box sx={{textAlign:"center"}} >Edit Tree</Box>
          <AddIcon sx={{fontSize:48}}/></IconButton>
          } 
          </Grid>
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>        
              { (trees?._id || reportTrees ) &&
              <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
              <Card
              style={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)", backgroundColor:"#FCFBFD"}}
              className={classes.clientContainer}
              >
               <CommonTable lable="generateReport" tableCols = {treeDetail} tableRows={reportTrees} component ="addTree"/>
               </Card>
               </Grid>
               }
              </Grid>
          </>
          :
           <MapContainer formik={formik} updateData={updateData}/>
         }

        </Grid>
      
    )
  }


  export const MapImage = (props) => {
    const { formik, staticMap , canvasRef, editClick, setActiveStep, setShow} = props
    const classes = profileSettingStyles()
    const mapImageRef= useRef(null)
    const excalidrawRef = useRef(null);
    const mapRef = useRef(null)
    const [map, setMap] = useState()

    const [editMode, setEditMode] = useState(formik.values.treeMapImage!=="" && formik.values.treeMapImage!==undefined ? false : true)
    const {trees} = useSelector(({tree})=> tree)
    const [processing, setProcessing] = useState(false)

    const points =[
      {lat: formik.values.treeLat, lng: formik.values.treeLong}
    ]
    useEffect(()=>{
      const scrollToBottom = () => {
        mapImageRef.current.scrollIntoView({ behavior: "smooth" });
      };
      scrollToBottom()
    },[])
    

    const onLoadMap = (map) => {
        mapRef.current = map;
        setMap(map)
    }
 

    const uploadTreeImage =(file)=>{
      const fileKey = trees?._id
      const params = {
        Bucket: 'arborhawkapp/treeImages',
        Key: fileKey,
        ContentType: file.type,
        Body: file
      };
      
     return new Promise((resolve, reject) => {
        s3.upload(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(data);
            console.log("dataaa", data)
          }
        });
      });
    }
  const updateScene = () => {
    const sceneData = {
      appState: {
        // zenModeEnabled: true,
        viewBackgroundColor: "transparent"
      }
    };
    excalidrawRef?.current?.updateScene(sceneData);
  };

  const editImage =()=>{
    setEditMode(true)
    formik.setFieldValue("treeMapImage", "")
    setActiveStep(4)   
    setShow(true)
  }

  useEffect(() => {
    setTimeout(() => {
      updateScene();
    }, 100);
  }, []);


  const handleUploadDrawing =()=>{
    setProcessing(true)
    html2canvas(canvasRef.current, { useCORS: true }).then(function(canvas) {     
      canvas.toBlob((blob)=>{
        console.log("blob", blob)
        uploadTreeImage(blob)
        .then((data) => {
          console.log('Images uploaded successfully:', data);
          formik.setFieldValue("treeMapImage", data.Location) 
          setProcessing(false)
          setEditMode(false)
          NotificationManager.success("Image saved successfully")
        })
        .catch((err) => {
          console.error('Error uploading images:', err);
        });
      })
  });

  }
          return (
            <>
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}} ref={mapImageRef}>
         <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid} style={{ height:500}}>
          {
          !editMode ? <img src ={formik.values.treeMapImage} alt="image"/> :
          <div className="image-container" ref={canvasRef}>
          <StaticGoogleMap
            maptype ="satellite"
            zoom={18}
            size="500x250"
            scale={2}
            apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} onLoad={onLoadMap}>
          <Marker
            location={{lat: formik.values.treeLat, lng: formik.values.treeLong}}
            color="red"
            size="small"
          />
        <Path
          points={points}
        />
    </StaticGoogleMap>
    <div className="excalidraw-container">
    <Excalidraw
        ref={excalidrawRef}
        initialData={[]}
        onChange={(elements, state) =>
          console.log("Elements: ", elements, "State: ", state)
        }
        onPointerUpdate={(payload) => console.log(payload)}
    />
      </div>
    </div>
    }
    </Grid>
      </Grid>
     <div style={{display:"flex", justifyContent:"center"}}>
     {
     editMode ?
    <Button  variant="contained"
      onClick={handleUploadDrawing}
      disabled={processing}
      style={{backgroundColor:!processing && "rgb(115 74 153)"}}
      component="span">{processing ? "Uploading..." : "Save Image"}</Button>
     :<Button  variant="contained"
      onClick={editImage}
      style={{backgroundColor:"rgb(115 74 153)"}}
      component="span">Edit Image</Button>
    }
     </div>
    </>
    )
  }

  const uploadImagesToS3 = (files) => {
    const promises = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileName = file.name;
      const fileType = file.type;
      const fileKey = `images/${fileName}`;

      const params = {
        Bucket: 'arborhawkapp/treeImages',
        Key: fileKey,
        ContentType: fileType,
        Body: file
      };

      const promise = new Promise((resolve, reject) => {
        s3.upload(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(data);
            console.log("dataaa", data)
          }
        });
      });

      promises.push(promise);
    }

    return Promise.all(promises);
  };

  export const TreeImage = (props) => {
    const { formik} = props
      const classes = profileSettingStyles()
      const {trees} = useSelector(({tree})=> tree)
      const [processing, setProcessing] = useState(false)
      const [image, setImage] = useState([])
      const [url, setUrl] = useState([])
      const params = {
        Bucket: 'arborhawkapp',
        Prefix: 'treeImages',
      };

      useEffect(()=>{
        s3.listObjectsV2(params, (err, data) => {
          if (err) {
            console.log(err);
            return;
          }
          // log the list of objects in the folder
        });
      },[])

  const handleRemove =(index)=>{
    const newImages = [...image];
    newImages.splice(index, 1);
    setImage(newImages);
  }

  const handleRemove1 = (index)=>{
    const newImages = [...formik.values.treeImage];
    newImages.splice(index,1);
    formik.setFieldValue("treeImage",newImages)
  }

  const handleImageChange=(e)=>{
    const files = e.target.files
    const newImages =[...image]
    for(let i=0; i<files.length;i++){
      const file= files[i]
      const previewUrl = URL.createObjectURL(file);
      newImages.push({ file, previewUrl });
    }
    setImage(newImages)
  }
  const handleUpload = () => {
    setProcessing(true)
    const files = image.map((image) => image.file);

    uploadImagesToS3(files)
      .then((data) => {
        setProcessing(false)
        console.log('Images uploaded successfully:', data);
        NotificationManager.success("Images uploaded successfully")
        setUrl(data.map((loc)=> loc.Location))
        // formik.setFieldValue("treeImage", data.location)
        setImage([]);
        const newImages = [...formik.values.treeImage];
        data.map((loc)=> (newImages.push(loc.Location))) 
        formik.setFieldValue("treeImage",newImages)
      })
      .catch((err) => {
        console.error('Error uploading images:', err);
      });
  };

    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
         <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
              <input
              // accept="image/*"
              type="file"
              multiple
              name="treeImage"
              id="select-image"
              onChange={handleImageChange}
              style={{ display: "none" }}
              // onChange={(e)=>formik.setFieldValue("treeImage", e.target.files)}
              // onChange={(e)=>handleFiles(e, formik.setFieldValue)}
            />
            <label htmlFor="select-image">
              <Button
                variant="contained"
                style={{backgroundColor:"rgb(115 74 153)"}}
                component="span"
              >
                Select Image
              </Button>
            </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
            {/* {(image?.length) ? (
              <Box mt={2} sx={{gap:8}} textAlign="center" style={{display:"flex", flexWrap:"wrap"}}>
                {
                  image?.map((url, index)=>
                  <div style={{position:"relative"}}>
                  <img src = {url.previewUrl} alt = {image.name} height="200px" width="250" />
                  <IconButton onClick={()=>handleRemove(index)}style={{padding:5, border:"1px solid black", backgroundColor:"#E5E4E2",width:20, height:20, cursor:"pointer" ,position:"absolute",right: 3,
                  top: 3}}><CloseIcon sx={{fontSize:15, color:"black"}}/></IconButton>
                  </div>
                  )}
              </Box>
            ):formik.values.treeImage ?(
              <Box mt={2} sx={{gap:8}} textAlign="center" style={{display:"flex", flexWrap:"wrap"}}>
                {
                  formik.values.treeImage?.map((url, index)=>
                  <img src = {url} alt = "image" height="200px" width="250" />
                  )}
              </Box>
            ):null} */}
              
              {formik.values.treeImage.length>0 &&  
               <Box mt={2} sx={{gap:8}} textAlign="center" style={{display:"flex", flexWrap:"wrap"}}>
               {
                 formik.values.treeImage?.map((url, index)=>
                 <div style={{position:"relative"}}>
                    <img src = {url} alt = "image" height="200px" width="250" />
                    <IconButton onClick={()=>handleRemove1(index)}style={{padding:5, border:"1px solid black", backgroundColor:"#E5E4E2",width:20, height:20, cursor:"pointer" ,position:"absolute",right: 3,
                    top: 3}}><CloseIcon sx={{fontSize:15, color:"black"}}/></IconButton>
                 </div>
                 )}
             </Box>
              }

              {image.length>0 &&  <Box mt={2} sx={{gap:8}} textAlign="center" style={{display:"flex", flexWrap:"wrap",marginLeft:"60px"}}>
                {
                  image?.map((url, index)=>
                  <div style={{position:"relative"}}>
                  <img src = {url.previewUrl} alt = {image.name} height="200px" width="250" />
                  <IconButton onClick={()=>handleRemove(index)}style={{padding:5, border:"1px solid black", backgroundColor:"#E5E4E2",width:20, height:20, cursor:"pointer" ,position:"absolute",right: 3,
                  top: 3}}><CloseIcon sx={{fontSize:15, color:"black"}}/></IconButton>
                  </div>
                  )}
              </Box>}
            
        </Grid>
        {image?.length > 0 && (
        <Grid item sm={12} xs={12} md={12} lg={12} className={classes.grid}>
          <Button
            variant="contained"
            disabled={processing}
            style={{backgroundColor: !processing && "rgb(115 74 153)"}}
            onClick={handleUpload}
            component="span" >
            {processing ? "Uploading..." : "Upload"}
          </Button>
          </Grid>
            )}
        </Grid>
    )
  }

  export const Species = (props) => {
    const { formik , setSpecies} = props

      const dispatch = useDispatch()
      const navigate = useNavigate()
      const classes = profileSettingStyles()
      const {species} = useSelector(({tree})=>tree)
        const [treeSpecies, setTreeSpecies] = useState([])

      useEffect(()=>{
          dispatch(fetchSpecies())
        },[])

      useEffect(()=>{
        console.log("value changes")
      },[formik.values.client])

    return (
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid} >
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={species}
          style={{width:"60%"}}
          className={classes.textField1}
          sx={{ width: 300 }}
          getOptionLabel={ (species) => species['commonName'] || species }
          getOptionSelected={(option, value) => option._id === value}
          value = {formik.values.species?.commonName}
          onChange={(e, val) => {
            formik.setFieldValue("species", val)
            setSpecies(val)
         }}

          // value={formik.values.species}
          // onChange={(e, value)=> formik.setFieldValue("species", value._id)}
          // error={formik.touched.species && Boolean(formik.errors.species)}
          // helperText={formik.touched.species && formik.errors.species}
          renderInput={(params) => <CssTextField {...params} className={classes.textField1} label="Species" />}
        />
          {/* <CssTextField
            required
            className={classes.textField1}
            variant="outlined"
            label="species"
            list='suggestion'
            name="species"
            value={formik.values.species}
            onChange={formik.handleChange}
            error={formik.touched.species && Boolean(formik.errors.species)}
            helperText={formik.touched.species && formik.errors.species}
          >
      </CssTextField> */}
            {/* <datalist id='suggestion'>
              {treeSpecies.map((name,index) =>{
                //Parsing the array and displaying suggestion with option tag
                  return (<option key={index} value={name}>{name}</option>)
                })}
       </datalist>     */}
        </Grid>
        </Grid>
    )
  }


  export const TreeHeight = (props) => {
    const { formik } = props
      const classes = profileSettingStyles()

      const option=[
       "ft",
       "m"
      ]
      useEffect(()=>{
        console.log("value changes")
      },[formik.values.client])
      return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>        
         <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
         <CssTextField
            required
            select
            // className={classes.textField1}
            variant="outlined"
            style={{marginRight:5}}
            // label="Select"
            name="treeHeightUnit"
            value={formik.values.treeHeightUnit}
            // onChange={formik.handleChange}
            onChange={(event)=>formik.setFieldValue("treeHeightUnit", event.target.value)}
            error={formik.touched.treeHeightUnit && Boolean(formik.errors.treeHeightUnit)}
            helperText={formik.touched.treeHeightUnit && formik.errors.treeHeightUnit}
          >
            {/* <MenuItem value={"null"} key={null}>
              {"Select Option"}
            </MenuItem> */}
            {option?.length && option?.map((op)=>
            <MenuItem value={op}>{op}</MenuItem>
            )}
        </CssTextField>
          <CssTextField
            className={classes.textField1}
            required
            type="number"
            variant="outlined"
            autocomplete="off"
            label="How big is this tree"
            name="treeHeight"
            value={formik.values.treeHeight}
            onChange={formik.handleChange}
            error={formik.touched.treeHeight && Boolean(formik.errors.treeHeight)}
            helperText={formik.touched.treeHeight && formik.errors.treeHeight}
          />
        </Grid>
        </Grid>
    )
  }


  export const HealthRating = (props) => {
    const { formik } = props

      const dispatch = useDispatch()
      const navigate = useNavigate()
      const classes = profileSettingStyles()
      const {healthRate} = useSelector(({tree})=> tree)

      useEffect(()=>{
          dispatch(fetchHealthRate())
        },[])

      useEffect(()=>{
        console.log("value changes")
      },[formik.values.client])


    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            required
            select
            className={classes.textField1}
            variant="outlined"
            label="Health Rating"
            name="healthRating"
            value={formik.values.healthRating}
            // onChange={formik.healthRating}
            onChange={(event)=>formik.setFieldValue("healthRating", event.target.value)}
            error={formik.touched.healthRating && Boolean(formik.errors.healthRating)}
            helperText={formik.touched.healthRating && formik.errors.healthRating}
          >
            <MenuItem value={"null"} key={null}>
              {"Select Rating"}
            </MenuItem>
            {healthRate?.length && healthRate?.map((op)=>
            <MenuItem value={op?._id}>{op?.rating}</MenuItem>
            )}
        </CssTextField>
        </Grid>
        </Grid>
    )
  }

  export const HardscapeDamage = (props) => {
    const { formik } = props
    const option=[
      "yes",
      "no",
      "potential"
    ]
      const dispatch = useDispatch()
      const navigate = useNavigate()
      const classes = profileSettingStyles()
      const { healthRate } = useSelector(({tree})=> tree)
      const [show, setShow] = useState(false)
      const [image, setImage]= useState("")
      const [imageUrl, setImageUrl]= useState("")
      const [processing, setProcessing] = useState(false)
      
   
      useEffect(()=>{
          dispatch(fetchHealthRate())
        },[])

      useEffect(()=>{
        formik.values.hardscapedamage === "yes" || formik.values.hardscapedamage === "potential" ? setShow(true) : setShow(false)
        if(formik.values.hardscapedamage === "no"){
          formik.setFieldValue("hardScapeDamageImage", " ")
          formik.setFieldValue("hardScapeDamageImageCaption", " ")
          setImageUrl("")
        }      
      },[formik.values.hardscapedamage])

      const handleImage =(e)=>{
        formik.setFieldValue("hardScapeDamageImage", "")
        formik.setFieldValue("hardScapeDamageImageCaption", "")
        setImage(e.target.files[0])
        const url = URL.createObjectURL(e.target.files[0])
        setImageUrl(url)
      }

      const handleRemove =()=>{
        setImage("")
        setImageUrl("")
        formik.setFieldValue("hardScapeDamageImageCaption", "")

      }
      const uploadImageToS3 = (bucket, key, file) => {
        return new Promise((resolve, reject) => {
          const params = {
            Bucket: bucket,
            Key: key,
            Body: file,
            ContentType: file.type,
          };
      
          s3.upload(params, (err, data) => {
            if (err) {
              reject(err);
            } else {
              console.log("er", data.Location)
              resolve({ url: data.Location, UniqueId: key });
            }
          });
        });
      };
      const handleUpload =()=>{
        setProcessing(true)
        uploadImageToS3(
          'arborhawkapp/treeImages',
          JSON.stringify(new Date().getTime()),
          image
        ) .then((res) => {
          setProcessing(false)
          setImageUrl("");
          formik.setFieldValue("hardScapeDamageImage", res.url)
          NotificationManager.success("Image uploaded successfully")
        })
        .catch((err) => {
          console.error('Error uploading image:', err);
        })
      }

      console.log("images", image, imageUrl)
    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            required
            select
            className={classes.textField1}
            variant="outlined"
            label="Is there Hardscape Damage"
            name="hardscapedamage"
            value={formik.values.hardscapedamage}
            // onChange={formik.handleChange}
            onChange={(event)=>formik.setFieldValue("hardscapedamage", event.target.value)}
            error={formik.touched.hardscapedamage && Boolean(formik.errors.hardscapedamage)}
            helperText={formik.touched.hardscapedamage && formik.errors.hardscapedamage}
          >
            <MenuItem value={"null"} key={null}>
              {"Select Option"}
            </MenuItem>
            {option?.length && option?.map((op)=>
            <MenuItem value={op}>{op}</MenuItem>
            )}
        </CssTextField>
        </Grid>
        {
          show &&
          <>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField            
            className = {classes.textField1}
            multiline
            rows={2}
            variant="outlined"
            label="Damage Reason"
            name="damageReason"
            value={formik.values.damageReason}
            onChange={formik.handleChange}
            // onChange={(event)=>formik.setFieldValue("client", event.target.value)}
            error={formik.touched.damageReason && Boolean(formik.errors.damageReason)}
            helperText={formik.touched.damageReason && formik.errors.damageReason}
          />
        </Grid>
     <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <label htmlFor="select-image" 
          style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap:2,
              cursor:"pointer"
          }}>
            <AttachmentIcon sx={{fontSize:40, color:"gray"}} /><span>Add an attachment</span>
         <input
           // accept="image/*"
           type="file"
           name="imageFile"
           id="select-image"
           onChange={handleImage}
           style={{ display: "none" }}
           />
         </label>
         </Grid>
         {
          formik.values.hardScapeDamageImage!=="" && formik.values.hardScapeDamageImage!==" " ? 
          <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
            <img src = {formik.values.hardScapeDamageImage} alt = {image ? image.name :"image"} height="200px" width="250" />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
             {formik.values.hardScapeDamageImageCaption}
              </Grid>
            </Grid>
           :imageUrl ?
          <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
            <div style={{position:"relative"}}>
            <img src = {imageUrl} alt = {image ? image.name :"image"} height="200px" width="250" />
            <IconButton onClick={()=>handleRemove()} style={{padding:5, border:"1px solid black", backgroundColor:"#E5E4E2",width:20, height:20, cursor:"pointer" ,position:"absolute",right: 3,
            top: 3}}><CloseIcon sx={{fontSize:15, color:"black"}}/></IconButton>
            </div>          
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
              <input 
                type="text" 
                placeholder='Enter caption' 
                onChange={formik.handleChange} 
                name="hardScapeDamageImageCaption" 
                value={formik.values.hardScapeDamageImageCaption}/>
              </Grid>
            </Grid>:
            null}
        {imageUrl &&  (
        <Grid item sm={12} xs={12} md={12} lg={12} className={classes.grid}>
          <Button
            variant="contained"
            disabled={processing}
            style={{backgroundColor: !processing && "rgb(115 74 153)"}}
            onClick={handleUpload}
            component="span" >
              {/* upload */}
            {processing ? "Uploading..." : "Upload"}
          </Button>
          </Grid>
            )}
         </>
        }
        
        </Grid>
    )
  }

  export const InspectionLevel = (props) => {
    const { formik } = props
    const level=[
      1,
      2,
      3]

      const dispatch = useDispatch()
      const navigate = useNavigate()
      const classes = profileSettingStyles()
      const {healthRate} = useSelector(({tree})=> tree)

    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            required
            select
            className={classes.textField1}
            variant="outlined"
            label="Select Level"
            name="level"
            value={formik.values.level}
            // onChange={formik.level}
            onChange={(event)=>formik.setFieldValue("level", event.target.value)}
            error={formik.touched.level && Boolean(formik.errors.level)}
            helperText={formik.touched.level && formik.errors.level}
          >
            <MenuItem value={"null"} key={null}>
              {"Select level"}
            </MenuItem>
            {level?.length && level?.map((op)=>
            <MenuItem value={op}>{op}</MenuItem>
            )}
        </CssTextField>
        </Grid>
        </Grid>
    )
  }

  export const TreeDistance = (props) => {
    const { formik } = props
    const treeDistance = [
      {option:"yes", value:true},
      {option:"no", value:false}
      ]
      const [show, setShow] = useState(false)
      const classes = profileSettingStyles()
      const {healthRate} = useSelector(({tree})=> tree)

      const [image, setImage]= useState("")
      const [imageUrl, setImageUrl]= useState("")
      const [processing, setProcessing] = useState(false)
  
  
      useEffect(()=>{
        formik.values.treeDistance === true ? setShow(true) : setShow(false)
        if(formik.values.treeDistance === false){
          formik.setFieldValue("treeDistanceImage", " ")
          formik.setFieldValue("treeDistanceImageCaption", " ")
          setImageUrl("")
        }   
      },[formik.values.treeDistance])

      const handleImage =(e)=>{
        
        formik.setFieldValue("treeDistanceImage", "")
        formik.setFieldValue("treeDistanceImageCaption", "")

        setImage(e.target.files[0])
        const url = URL.createObjectURL(e.target.files[0])
        setImageUrl(url)
      }

      const handleRemove =()=>{
        setImage("")
        setImageUrl("")
        formik.setFieldValue("treeDistanceImageCaption", "")

      }
      const uploadImageToS3 = (bucket, key, file) => {
        return new Promise((resolve, reject) => {
          const params = {
            Bucket: bucket,
            Key: key,
            Body: file,
            ContentType: file.type,
          };
      
          s3.upload(params, (err, data) => {
            if (err) {
              reject(err);
            } else {
              resolve({ url: data.Location, UniqueId: key });
            }
          });
        });
      };
      const handleUpload =()=>{
        setProcessing(true)
        uploadImageToS3(
          'arborhawkapp/treeImages',
          JSON.stringify(new Date().getTime()),
          image
        ) .then((res) => {
          setProcessing(false)
          setImageUrl("");
          formik.setFieldValue("treeDistanceImage", res.url)
          NotificationManager.success("Image uploaded successfully")
        })
        .catch((err) => {
          console.error('Error uploading image:', err);
        })
      }
    

    return (
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            required
            select
            className={classes.textField1}
            variant="outlined"
            label="Is the tree near any structure or power lines"
            name="treeDistance"
            value={formik.values.treeDistance}
            // onChange={formik.handleChange}
            onChange={(event)=> {formik.setFieldValue("treeDistance", event.target.value)}}
            error={formik.touched.treeDistance && Boolean(formik.errors.treeDistance)}
            helperText={formik.touched.treeDistance && formik.errors.treeDistance}
          >
            <MenuItem value={"null"} key={null}>
              {"Select Option"}
            </MenuItem>
            {treeDistance?.length && treeDistance?.map((op)=>
            <MenuItem value={op.value}>{op.option}</MenuItem>
            )}
        </CssTextField>
        </Grid>
        {
          show &&
          <>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            className={classes.textField1}
            variant="outlined"
            multiline
            rows={2}
            label="Description"
            name="treeDistanceDesc"
            value={formik.values.treeDistanceDesc}
            onChange={formik.handleChange}
            // onChange={(event)=>formik.setFieldValue("client", event.target.value)}
            error={formik.touched.treeDistanceDesc && Boolean(formik.errors.treeDistanceDesc)}
            helperText={formik.touched.treeDistanceDesc && formik.errors.treeDistanceDesc}
          />
        </Grid>
           <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
           <label htmlFor="select-image" 
           style={{
               display: 'flex',
               alignItems: 'center',
               flexWrap: 'wrap',
               gap:2,
               cursor:"pointer"
           }}>
             <AttachmentIcon sx={{fontSize:40, color:"gray"}} /><span>Add an attachment</span>
          <input
            // accept="image/*"
            type="file"
            name="imageFile"
            id="select-image"
            onChange={handleImage}
            style={{ display: "none" }}
            />
          </label>
          </Grid>
          {
           formik.values.treeDistanceImage!=="" && formik.values.treeDistanceImage!==" " ? 
           <Grid container>
           <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
             <img src = {formik.values.treeDistanceImage} alt = {image ? image.name :"image"} height="200px" width="250" />
             </Grid>
             <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
              {formik.values.treeDistanceImageCaption}
               </Grid>
             </Grid>
            :imageUrl ?
           <Grid container>
           <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
             <div style={{position:"relative"}}>
             <img src = {imageUrl} alt = {image ? image.name :"image"} height="200px" width="250" />
             <IconButton onClick={()=>handleRemove()} style={{padding:5, border:"1px solid black", backgroundColor:"#E5E4E2",width:20, height:20, cursor:"pointer" ,position:"absolute",right: 3,
             top: 3}}><CloseIcon sx={{fontSize:15, color:"black"}}/></IconButton>
             </div>          
             </Grid>
             <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
               <input 
                 type="text" 
                 placeholder='Enter caption' 
                 onChange={formik.handleChange} 
                 name="treeDistanceImageCaption" 
                 value={formik.values.treeDistanceImageCaption}/>
               </Grid>
             </Grid>:
             null}
         {imageUrl &&  (
         <Grid item sm={12} xs={12} md={12} lg={12} className={classes.grid}>
           <Button
             variant="contained"
             disabled={processing}
             style={{backgroundColor: !processing && "rgb(115 74 153)"}}
             onClick={handleUpload}
             component="span" >
               {/* upload */}
             {processing ? "Uploading..." : "Upload"}
           </Button>
           </Grid>
             )}
          </>
         
        }
        </Grid>
    )
  }

  export const HeritageTree = (props) => {
    const { formik } = props
    const heritage = [
      {option:"yes", value:true},
      {option:"no", value:false}
      ]
      const dispatch = useDispatch()
      const navigate = useNavigate()
      const classes = profileSettingStyles()
      const {healthRate} = useSelector(({tree})=> tree)
      const [show, setShow] = useState(false)
      const [image, setImage]= useState("")
      const [imageUrl, setImageUrl]= useState("")
      const [processing, setProcessing] = useState(false)
  
      useEffect(()=>{
        formik.values.heritageTree === true ? setShow(true) : setShow(false)
        if(formik.values.heritageTree === false){
          formik.setFieldValue("heritageImage", " ")
          formik.setFieldValue("heritageImageCaption", " ")
          setImageUrl("")
        }   
      },[formik.values.heritageTree])


      const handleImage =(e)=>{
        formik.setFieldValue("heritageImage", "")
        formik.setFieldValue("heritageImageCaption", "")
        setImage(e.target.files[0])
        const url = URL.createObjectURL(e.target.files[0])
        setImageUrl(url)
      }

      const handleRemove =()=>{
        setImage("")
        setImageUrl("")
        formik.setFieldValue("heritageImageCaption", "")
      }
      const uploadImageToS3 = (bucket, key, file) => {
        return new Promise((resolve, reject) => {
          const params = {
            Bucket: bucket,
            Key: key,
            Body: file,
            ContentType: file.type,
          };
      
          s3.upload(params, (err, data) => {
            if (err) {
              reject(err);
            } else {
              resolve({ url: data.Location, UniqueId: key });
            }
          });
        });
      };
      const handleUpload =()=>{
        setProcessing(true)
        uploadImageToS3(
          'arborhawkapp/treeImages',
          JSON.stringify(new Date().getTime()),
          image
        ) .then((res) => {
          setProcessing(false)
          setImageUrl("");
          formik.setFieldValue("heritageImage", res.url)
          NotificationManager.success("Image uploaded successfully")
        })
        .catch((err) => {
          console.error('Error uploading image:', err);
        })
      }

    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            required
            select
            className={classes.textField1}
            variant="outlined"
            label="Is this a heritage tree"
            name="heritageTree"
            value={formik.values.heritageTree}
            // onChange={formik.handleChange}
            onChange={(event)=>formik.setFieldValue("heritageTree", event.target.value)}
            error={formik.touched.heritageTree && Boolean(formik.errors.heritageTree)}
            helperText={formik.touched.heritageTree && formik.errors.heritageTree}
          >
            <MenuItem value={"null"} key={null}>
              {"Select Option"}
            </MenuItem>
            {heritage?.length && heritage?.map((op)=>
            <MenuItem value={op.value}>{op.option}</MenuItem>
            )}
        </CssTextField>
        </Grid>
        {
          show &&
          <>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            className={classes.textField1}
            variant="outlined"
            multiline
            rows={2}
            label="Description"
            name="heritageDesc"
            value={formik.values.heritageDesc}
            onChange={formik.handleChange}
            // onChange={(event)=>formik.setFieldValue("client", event.target.value)}
            error={formik.touched.heritageDesc && Boolean(formik.errors.heritageDesc)}
            helperText={formik.touched.heritageDesc && formik.errors.heritageDesc}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
       <label htmlFor="select-image" 
        style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap:2,
            cursor:"pointer"
        }}>
          <AttachmentIcon sx={{fontSize:40, color:"gray"}} /><span>Add an attachment</span>
       <input
         // accept="image/*"
         type="file"
         name="imageFile"
         id="select-image"
         onChange={handleImage}
         style={{ display: "none" }}
         />
       </label>
       </Grid>
       {
        formik.values.heritageImage!=="" && formik.values.heritageImage!==" " ? 
        <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <img src = {formik.values.heritageImage} alt = {image ? image.name :"image"} height="200px" width="250" />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
           {formik.values.heritageImageCaption}
            </Grid>
          </Grid>
         :imageUrl ?
        <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <div style={{position:"relative"}}>
          <img src = {imageUrl} alt = {image ? image.name :"image"} height="200px" width="250" />
          <IconButton onClick={()=>handleRemove()} style={{padding:5, border:"1px solid black", backgroundColor:"#E5E4E2",width:20, height:20, cursor:"pointer" ,position:"absolute",right: 3,
          top: 3}}><CloseIcon sx={{fontSize:15, color:"black"}}/></IconButton>
          </div>          
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
            <input 
              type="text" 
              placeholder='Enter caption' 
              onChange={formik.handleChange} 
              name="heritageImageCaption" 
              value={formik.values.heritageImageCaption}/>
            </Grid>
          </Grid>:
          null}
      {imageUrl &&  (
      <Grid item sm={12} xs={12} md={12} lg={12} className={classes.grid}>
        <Button
          variant="contained"
          disabled={processing}
          style={{backgroundColor: !processing && "rgb(115 74 153)"}}
          onClick={handleUpload}
          component="span" >
            {/* upload */}
          {processing ? "Uploading..." : "Upload"}
        </Button>
        </Grid>
          )}
       </>
      }
        
        </Grid>
    )
  }

  export const TreeJurisdiction = (props) => {
    const { formik } = props
       const dispatch = useDispatch()
      const classes = profileSettingStyles()
      const {jurisdiction} = useSelector(({tree})=> tree)

      console.log("jurisdiction", jurisdiction)
      useEffect(()=>{
        dispatch(getJurisdiction())
      },[])


    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            required
            select
            className={classes.textField1}
            variant="outlined"
            label="Jurisdiction"
            name="jurisdiction"
            value={formik.values.jurisdiction}
            onChange={(event)=>formik.setFieldValue("jurisdiction", event.target.value)}
            error={formik.touched.jurisdiction && Boolean(formik.errors.jurisdiction)}
            helperText={formik.touched.jurisdiction && formik.errors.jurisdiction}
          >
            <MenuItem value={"null"} key={null}>
              {"Select Jurisdiction"}
            </MenuItem>
            {jurisdiction?.length && jurisdiction?.map((op)=>
            <MenuItem value={op?._id}>{op?.jurisdiction}</MenuItem>
            )}
        </CssTextField>
        </Grid>
        </Grid>
    )
  }

  export const DiseasePresent = (props) => {
    const { formik } = props
    const DiseasesPresent = [
      {option:"yes", value:true},
      {option:"no",  value:false}
      ]

      const [show, setShow] = useState(false)
      const classes = profileSettingStyles()

      const [image, setImage]= useState("")
      const [imageUrl, setImageUrl]= useState("")
      const [processing, setProcessing] = useState(false)
  
  
      useEffect(()=>{
        formik.values.diseasePresent === true ? setShow(true) : setShow(false)
        if(formik.values.diseasePresent === false){
          formik.setFieldValue("diseasePresentImage", " ")
          formik.setFieldValue("diseasePresentImageCaption", " ")
          setImageUrl("")
        }   
      },[formik.values.diseasePresent])

      const handleImage =(e)=>{
        formik.setFieldValue("diseasePresentImage", "")
        formik.setFieldValue("diseasePresentImageCaption", "")
        setImage(e.target.files[0])
        const url = URL.createObjectURL(e.target.files[0])
        setImageUrl(url)
      }

      const handleRemove =()=>{
        setImage("")
        setImageUrl("")
        formik.setFieldValue("diseasePresentImageCaption", "")
      }
      const uploadImageToS3 = (bucket, key, file) => {
        return new Promise((resolve, reject) => {
          const params = {
            Bucket: bucket,
            Key: key,
            Body: file,
            ContentType: file.type,
          };
      
          s3.upload(params, (err, data) => {
            if (err) {
              reject(err);
            } else {
              console.log("er", data.Location)
              resolve({ url: data.Location, UniqueId: key });
            }
          });
        });
      };
      const handleUpload =()=>{
        setProcessing(true)
        uploadImageToS3(
          'arborhawkapp/treeImages',
          JSON.stringify(new Date().getTime()),
          image
        ) .then((res) => {
          setProcessing(false)
          setImageUrl("");
          formik.setFieldValue("diseasePresentImage", res.url)
          NotificationManager.success("Image uploaded successfully")
        })
        .catch((err) => {
          console.error('Error uploading image:', err);
        })
      }
    

    return (
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            required
            select
            className={classes.textField1}
            variant="outlined"
            label="Any Disease Present"
            name="diseasePresent"
            value={formik.values.diseasePresent}
            // onChange={formik.handleChange}
            onChange={(event)=> {formik.setFieldValue("diseasePresent", event.target.value)}}
            error={formik.touched.diseasePresent && Boolean(formik.errors.diseasePresent)}
            helperText={formik.touched.diseasePresent && formik.errors.diseasePresent}
          >
            <MenuItem value={"null"} key={null}>
              {"Select Option"}
            </MenuItem>
            {DiseasesPresent?.length && DiseasesPresent?.map((op)=>
            <MenuItem value={op.value}>{op.option}</MenuItem>
            )}
        </CssTextField>
        </Grid>
        {
          show &&
          <>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            className={classes.textField1}
            variant="outlined"
            multiline
            rows={2}
            label="Description"
            name="diseasePresentDesc"
            value={formik.values.diseasePresentDesc}
            onChange={formik.handleChange}
            // onChange={(event)=>formik.setFieldValue("client", event.target.value)}
            error={formik.touched.diseasePresentDesc && Boolean(formik.errors.diseasePresentDesc)}
            helperText={formik.touched.diseasePresentDesc && formik.errors.diseasePresentDesc}
          />
        </Grid>
           <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
           <label htmlFor="select-image" 
           style={{
               display: 'flex',
               alignItems: 'center',
               flexWrap: 'wrap',
               gap:2,
               cursor:"pointer"
           }}>
             <AttachmentIcon sx={{fontSize:40, color:"gray"}} /><span>Add an attachment</span>
          <input
            // accept="image/*"
            type="file"
            name="imageFile"
            id="select-image"
            onChange={handleImage}
            style={{ display: "none" }}
            />
          </label>
          </Grid>
          {
           formik.values.diseasePresentImage!=="" && formik.values.diseasePresentImage!==" " ? 
           <Grid container>
           <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
             <img src = {formik.values.diseasePresentImage} alt = {image ? image.name :"image"} height="200px" width="250" />
             </Grid>
             <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
              {formik.values.diseasePresentImageCaption}
               </Grid>
             </Grid>
            :imageUrl ?
           <Grid container>
           <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
             <div style={{position:"relative"}}>
             <img src = {imageUrl} alt = {image ? image.name :"image"} height="200px" width="250" />
             <IconButton onClick={()=>handleRemove()} style={{padding:5, border:"1px solid black", backgroundColor:"#E5E4E2",width:20, height:20, cursor:"pointer" ,position:"absolute",right: 3,
             top: 3}}><CloseIcon sx={{fontSize:15, color:"black"}}/></IconButton>
             </div>          
             </Grid>
             <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
               <input 
                 type="text" 
                 placeholder='Enter caption' 
                 onChange={formik.handleChange} 
                 name="diseasePresentImageCaption" 
                 value={formik.values.diseasePresentImageCaption}/>
               </Grid>
             </Grid>:
             null}
         {imageUrl &&  (
         <Grid item sm={12} xs={12} md={12} lg={12} className={classes.grid}>
           <Button
             variant="contained"
             disabled={processing}
             style={{backgroundColor: !processing && "rgb(115 74 153)"}}
             onClick={handleUpload}
             component="span" >
               {/* upload */}
             {processing ? "Uploading..." : "Upload"}
           </Button>
           </Grid>
             )}
          </>
         
        }
        </Grid>
    )
  }
  export const Observations = (props) => {
    const { formik } = props


      const dispatch = useDispatch()
      const navigate = useNavigate()
      const classes = profileSettingStyles()
      useEffect(()=>{
        dispatch(fetchRecomendation())
      },[])
        const handleOnChange = (event) => {
          console.log("Form::onChange", event, event.target);
        };

    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            required
            className={classes.textField1}
            variant="outlined"
            label="Observations"
            multiline
            rows={4}
            name="observations"
            value={formik.values.observations}
            onChange={formik.handleChange}
            // onChange={(event)=>formik.setFieldValue("client", event.target.value)}
            error={formik.touched.observations && Boolean(formik.errors.observations)}
            helperText={formik.touched.observations && formik.errors.observations}
          />
        </Grid>
        </Grid>
    )
  }

  export const SecondaryReport = (props) => {
    const { formik } = props

    const classes = profileSettingStyles()

    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
            required
            select
            className={classes.textField1}
            variant="outlined"
            label="Is Secondary Report Required"
            name="secondaryReport"
            value={formik.values.secondaryReport}
            onChange={(event)=>formik.setFieldValue("secondaryReport", event.target.value)}
            error={formik.touched.secondaryReport && Boolean(formik.errors.secondaryReport)}
            helperText={formik.touched.secondaryReport && formik.errors.secondaryReport}
          >
            <MenuItem value={"null"} key={null}>
              {"Select"}
            </MenuItem>
            <MenuItem value={true}>Yes</MenuItem>
            <MenuItem value={false}>No</MenuItem>          
        </CssTextField>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          {/* <CssTextField
            
            className={classes.textField1}
            variant="outlined"
            label="Description"
            multiline
            rows={4}
            name="recomendationDesc"
            value={formik.values.recomendationDesc}
            onChange={formik.handleChange}
            // onChange={(event)=>formik.setFieldValue("client", event.target.value)}
            error={formik.touched.recomendationDesc && Boolean(formik.errors.recomendationDesc)}
            helperText={formik.touched.recomendationDesc && formik.errors.recomendationDesc}
          /> */}
        </Grid>
        </Grid>
    )
  }
  

  export const Recomendation = (props) => {
    const { formik } = props

      const dispatch = useDispatch()
      const navigate = useNavigate()
      const [show, setShow] = useState(false)
      const classes = profileSettingStyles()
      const {recomendations} = useSelector(({tree})=> tree)


    return (
          <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          <CssTextField
            required
            select
            className={classes.textField1}
            variant="outlined"
            label="Recomendation"
            name="recomendation"
            value={formik.values.recomendation}
            onChange={(event)=>formik.setFieldValue("recomendation", event.target.value)}
            error={formik.touched.recomendation && Boolean(formik.errors.recomendation)}
            helperText={formik.touched.recomendation && formik.errors.recomendation}
          >
            <MenuItem value={"null"} key={null}>
              {"Select Recomendation"}
            </MenuItem>
            {recomendations?.length && recomendations?.map((op)=>
            <MenuItem value={op?._id}>{op?.recomendation}</MenuItem>
            )}
        </CssTextField>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
          {/* <CssTextField
            
            className={classes.textField1}
            variant="outlined"
            label="Description"
            multiline
            rows={4}
            name="recomendationDesc"
            value={formik.values.recomendationDesc}
            onChange={formik.handleChange}
            // onChange={(event)=>formik.setFieldValue("client", event.target.value)}
            error={formik.touched.recomendationDesc && Boolean(formik.errors.recomendationDesc)}
            helperText={formik.touched.recomendationDesc && formik.errors.recomendationDesc}
          /> */}
        </Grid>
        </Grid>
    )
  }